import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth";
import { getStorage} from "firebase/storage";
import { getFirestore} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCnjbNZHaQ2d9WhcqZHKuYUM7ePNPTtZhU",
  authDomain: "convoconnect-19f57.firebaseapp.com",
  projectId: "convoconnect-19f57",
  storageBucket: "convoconnect-19f57.appspot.com",
  messagingSenderId: "376636424448",
  appId: "1:376636424448:web:f85e34653581fc191bb3e5"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();
